export function filterToQuery(filter) {
	if (!filter) return ""
	let query = {}
	for (let item of filter) {
		if (!item.field) continue

		let val = item.value

		if (typeof item.value === "object") {
			val = item.value?.id ?? item.value?.value ?? item.value
		} else if (Array.isArray(item.value)) {
			val = item.value.map(item => item.id)
		}

		if (!item.operator) {
			query[`${item.field.field}`] = val
			continue
		}

		query[`${item.operator},${item.field.field}`] = val
	}
	return query
}